module.exports = __webpack_public_path__ + "static/media/b3.813cb261.jpg";